import { fork } from 'redux-saga/effects';
import userSaga from './userSaga';
import coreSaga from './coreSaga';

function* rootSaga() {
  yield fork(userSaga);
  yield fork(coreSaga);
}

export default rootSaga;
